import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Card, Spinner, Form } from "react-bootstrap";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import moment from "moment";
import ComanConfirmationModal from "../../../components/ComanConfirmationModal";
import { toast } from "react-toastify";
import { IconTrash } from "@tabler/icons-react";

function PackingSlipHistory({
  orderId,
  isPackageHistoryDialogOpen,
  setIsPackageHistoryDialogOpen,
}) {
  const [packageHistory, setPackageHistory] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const { data: fetcheddata, postData: GetPackigSlip } = usePostRequest(
    API_ENDPOINTS.GET_PACKING_SLIP
  );

  const { isLoading: deleteRecord, postData: DeleteRecord } = usePostRequest(
    API_ENDPOINTS.DELETE_PACKING_SLIP
  );

  useEffect(() => {
    GetPackigSlip({ order_id: orderId });
  }, [orderId]);

  useEffect(() => {
    console.log("fetcheddata", fetcheddata);
    if (fetcheddata?.data) {
      setPackageHistory(fetcheddata.data);
    }
  }, [fetcheddata]);

  const onDeleteSuccess = (res) => {
    toast.success(res?.message || "Record deleted successfully");
    GetPackigSlip({ order_id: orderId });
  };

  const onDeleteError = (err) => {
    toast.error(err?.message || "Failed to delete record");
  };

  const openModal = (id) => {
    let modalMessage = "Are you sure you want to delete this record?";
    let modalTitle = "Delete Packing Slip Record";
    let type = "danger";
    let modalIcon = <IconTrash />;
    let action = "delete";

    // ✅ bind the function to this id right away
    const handleDeleteRecord = () => {
      DeleteRecord({ id }, onDeleteSuccess, onDeleteError);
      setIsModalOpen({ ...isModalOpen, show: false }); // close modal after delete
    };

    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: handleDeleteRecord, // already bound to id
      title: modalTitle,
      icon: modalIcon,
      type,
    });
  };

  return (
    <>
      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />
      <Modal
        show={isPackageHistoryDialogOpen}
        onHide={() => {
          setIsPackageHistoryDialogOpen(false);
        }}
        size="lg"
      >
        <Modal.Header className="d-flex gap-3" closeButton>
          <h5>Packing Slip History</h5>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive mail_wrapper p-0 border-0 mb-0 box-shadow-none">
            <Table className="table-bordered card-table">
              <thead>
                <tr>
                  <th>FROM ADDRESS</th>
                  <th>TO ADDRESS</th>
                  <th>DELIVER TO CUSTOMER</th>
                  <th>SHIP DATE</th>
                  <th>VIEW</th>
                  <th>DELETE</th>
                </tr>
              </thead>
              <tbody>
                {!packageHistory || packageHistory.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No history found.
                    </td>
                  </tr>
                ) : (
                  packageHistory.map((field) => (
                    <tr key={field.id}>
                      <td>{field.from_address}</td>
                      <td>{field.to_address}</td>
                      <td>{field.deliver_to_customer === 0 ? "No" : "Yes"}</td>
                      <td>{moment(field.ship_date).format("MM-DD-YYYY")}</td>
                      <td>
                        <Button>View</Button>
                      </td>
                      <td>
                        <Button
                          variant="warning"
                          onClick={() => openModal(field?.id)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PackingSlipHistory;
